import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { authAxios } from '@/lib/axios';
import {
  parseSocialOauthRelayPlatform,
  replaceCurrentWindow,
  resolveAuthorizationRedirect,
} from '@/lib/account-settings/socialOauthRelay';

const SocialOauthRelay = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const platform = parseSocialOauthRelayPlatform(searchParams.toString());
  const [failed, setFailed] = useState(false);
  const started = useRef(false);

  useEffect(() => {
    if (!platform || started.current) return;
    started.current = true;

    const start = async () => {
      try {
        const response = await authAxios.get(`/api/social-connections/${platform}/start`);
        const authorizationUrl = resolveAuthorizationRedirect(response.data);
        if (!authorizationUrl) {
          setFailed(true);
          return;
        }
        replaceCurrentWindow(authorizationUrl);
      } catch {
        setFailed(true);
      }
    };

    void start();
  }, [platform]);

  const title = failed
    ? t('account.socialConnectionFailed')
    : t('account.socialOauthRelay.title');
  const description = !platform
    ? t('account.socialOauthRelay.invalidPlatform')
    : failed
      ? t('account.socialOauthRelay.startFailed')
      : t('account.socialOauthRelay.body');

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle>{title}</CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
        <CardContent>
          {platform && !failed ? (
            <div className="flex justify-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
            </div>
          ) : null}
        </CardContent>
      </Card>
    </div>
  );
};

export default SocialOauthRelay;
